import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

export class Unibrow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
    };
  }

  closeUnibrow(e) {
    e.preventDefault;
    this.setState({ show: false });
    if (this.props.onClose) this.props.onClose();
  }

  render() {
    const { state, props } = this;
    const closeUnibrow = this.closeUnibrow.bind(this);

    if (!state.show) return null;

    return (
      <div className="wp-unibrow">
        {props.leftContent && <div className="left">{props.leftContent}</div>}

        {props.children && <div className="center">{props.children}</div>}

        {props.rightContent && <div className="left">{props.rightContent}</div>}

        {props.showCloseButton && (
          <div className="close-btn">
            <a onClick={closeUnibrow}>
              <FontAwesome name="times-thin" />
            </a>
          </div>
        )}
      </div>
    );
  }
}
Unibrow.propTypes = {
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
  children: PropTypes.node,
};

export default Unibrow;
